import { getDashboardUrl } from "@areahub/config";
import { Link, PricingOptionsProps } from "@areahub/ui";
import {
  Box,
  BoxProps,
  Button,
  Flex,
  Heading,
  List,
  ListIcon,
  Text,
  VStack,
} from "@chakra-ui/react";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { FaCheckCircle } from "react-icons/fa";
import { blockRenderers } from "../../../../../apps/www/components/individuals/mdx-components";
import { MobilePriceCard } from "./mobile-price-card";

export interface PriceCardProps extends BoxProps {
  title: string;
  pricingOptions: PricingOptionsProps[];
  featureList: any[];
  button: string;
  mobileSubtitle: string;
  desktopSubtitle: string;
  planImage: any;
  plan: string;
}

export const PriceCard = ({
  title,
  pricingOptions,
  featureList,
  button,
  planImage,
  mobileSubtitle,
  desktopSubtitle,
  plan,
}: PriceCardProps) => {
  const planItem = pricingOptions.find((item) => item.title === plan);
  const price = planItem?.price;

  return (
    <>
      {/* Desktop Display */}
      <Box
        p={{
          base: 0,
          md: 3,
          lg: 5,
        }}
        borderRadius={{
          base: "xl",
          md: "none",
        }}
        position="relative"
        w="100%"
        h={{
          md: "750px",
          xl: "720px",
        }}
        display={{
          base: "none",
          md: "block",
        }}
      >
        <Box
          maxW={{ lg: "350px" }}
          minW={{
            base: "90vw",
            md: "230px",
          }}
          h="100%"
          bgColor="white"
          border="1px solid black"
          borderRadius="lg"
          boxShadow={{
            base: "1px 2px 5px 1px rgba(136, 136, 136, 0.8)",
            md: "none",
          }}
        >
          <Flex
            flexDir={{
              base: "row",
              md: "column",
            }}
            gap={6}
            px={{
              base: 5,
              md: 0,
            }}
            py={2}
          >
            <>
              <VStack borderBottom="1px solid black" pt={4} pb={3}>
                <Heading fontSize={20} fontWeight="extrabold">
                  {title}
                </Heading>
                <Text fontSize={15} fontWeight="bold" color="#3B82F6">
                  {desktopSubtitle}
                </Text>
              </VStack>

              {/* Plan Description */}
              <Flex flexDir="column" px={{ base: 3, lg: 5 }}>
                <VStack filter={`${plan === "Pro" ? "blur(7px)" : ""}`}>
                  <Text fontSize={26} fontWeight="extrabold" pb={5}>
                    {plan === "Pro" ? "$" : ""}
                    {price}
                  </Text>
                </VStack>
                <List filter={`${plan === "Pro" ? "blur(7px)" : ""}`}>
                  {featureList.map((item, idx) => (
                    <Flex
                      key={`${idx}-${item?.title?.toLowerCase()}`}
                      fontSize={{
                        md: 12,
                        xl: 13,
                      }}
                      fontWeight="500"
                      pb={2}
                    >
                      <ListIcon as={FaCheckCircle} color="gray.600" my="3px" />
                      <RichText
                        content={item?.feature?.raw}
                        renderers={blockRenderers}
                      />
                    </Flex>
                  ))}
                </List>

                {plan === "Pro" ? (
                  <Button
                    disabled
                    cursor={"unset"}
                    bgColor="#3B82F6"
                    fontWeight="bold"
                    color="white"
                    mb={12}
                    position="absolute"
                    bottom={0}
                    left="50%"
                    transform="translate(-50%, -50%)"
                    w="75%"
                    textTransform="uppercase"
                    _hover={{
                      bgColor: "#3B82F6",
                    }}
                  >
                    {button}
                  </Button>
                ) : (
                  <Link href="/enterprise-contact">
                    <Button
                      bgColor="#3B82F6"
                      fontWeight="bold"
                      color="white"
                      mb={12}
                      position="absolute"
                      bottom={0}
                      left="50%"
                      transform="translate(-50%, -50%)"
                      w="75%"
                      textTransform="uppercase"
                    >
                      {button}
                    </Button>
                  </Link>
                )}
              </Flex>
            </>
          </Flex>
        </Box>
      </Box>

      {/* Mobile Display */}
      <MobilePriceCard
        title={title}
        pricingOptions={pricingOptions}
        featureList={featureList}
        button={button}
        mobileSubtitle={mobileSubtitle}
        desktopSubtitle={desktopSubtitle}
        planImage={planImage}
        plan={plan}
      />
    </>
  );
};
